import { combineReducers } from 'redux';
import { type IModule } from 'redux-dynamic-modules';

import { inherentRisksApi } from '../../features/Details/components/EntitlementDetails/InherentRisksTab/data-layer/inherentRisksApi';
import { usersApi } from '../../features/Details/components/EntitlementDetails/UsersTab/data-layer/usersApi';
import { detailsApi } from '../../features/Details/data-layer/detailsApi';
import detailsReducer from '../../features/Details/data-store/detailsSlice';
import { entReportsApiEndpoints } from '../../features/EntitlementReports/data-layer/entReportsApi';
import entReportsReducer from '../../features/EntitlementReports/data-store/entReportsSlice';
import { entitlementTabApi } from '../../features/ViolationsEntitlement/data-layer/entitlementTabApi';
import entitlementReducer from '../../features/ViolationsEntitlement/data-store/entitlementSlice';
import { violationsReportApi } from '../../features/ViolationsReport/data-layer/violationsReportApi';
import violationsReportReducer from '../../features/ViolationsReport/data-store/violationsReportSlice';
import violationsRoleReducer from '../../features/ViolationsRole/data-store/violationsRoleSlice';
import { violationsTabApi } from '../../features/ViolationsTab/data-layer/violationsTabApi';
import violationsTabReducer from '../../features/ViolationsTab/data-store/violationsTabSlice';
import violationsTimeReducer from '../../features/ViolationsTime/data-store/violationsTimeSlice';
import violationsUserReducer from '../../features/ViolationsUser/data-store/violationsUserSlice';
import { auditLogApi } from '../../pages/AuditLogViewer/data-layer/auditLogApi';
import { auditLogReducer } from '../../pages/AuditLogViewer/data-store';

import { alertManagerReducer } from './alertManagerSlice';
import { alertQueueReducer } from './alertQueueSlice';
import { aagGlobalApi } from './globalApis';
import globalReducer from './globalSlice';

export const AAGReducer = combineReducers({
  global: globalReducer,
  alertManager: alertManagerReducer,
  alertQueue: alertQueueReducer,
  details: detailsReducer,
  violationsTab: violationsTabReducer,
  time: violationsTimeReducer,
  user: violationsUserReducer,
  entitlement: entitlementReducer,
  role: violationsRoleReducer,
  report: violationsReportReducer,
  entReports: entReportsReducer,
  auditLog: auditLogReducer,
});

// Club AAG reducer and API slices together and register middleware here
export const aagApiMiddleware = {
  middleware: [
    violationsTabApi.middleware,
    detailsApi.middleware,
    aagGlobalApi.middleware,
    violationsReportApi.middleware,
    entReportsApiEndpoints.middleware,
    entitlementTabApi.middleware,
    inherentRisksApi.middleware,
    auditLogApi.middleware,
    usersApi.middleware,
  ],
};

/**
 * Neo AAG module for home page store
 * @description Creates and returns a Redux Dynamic Module for the AAG feature.
 * This module includes the combined AAG reducer and API reducers for the violations tab
 * and global API endpoints.
 * @returns {IModule<unknown>} A Redux Dynamic Module containing the AAG reducers
 */
export function neoAAGModule(): IModule<unknown> {
  return {
    id: 'neoAAGModule',
    reducerMap: {
      aag: AAGReducer,
      [violationsTabApi.reducerPath]: violationsTabApi.reducer,
      [detailsApi.reducerPath]: detailsApi.reducer,
      [aagGlobalApi.reducerPath]: aagGlobalApi.reducer,
      [violationsReportApi.reducerPath]: violationsReportApi.reducer,
      [entReportsApiEndpoints.reducerPath]: entReportsApiEndpoints.reducer,
      [entitlementTabApi.reducerPath]: entitlementTabApi.reducer,
      [inherentRisksApi.reducerPath]: inherentRisksApi.reducer,
      [auditLogApi.reducerPath]: auditLogApi.reducer,
      [usersApi.reducerPath]: usersApi.reducer,
    },
  };
}
